import React, { useState, useEffect } from "react";
import { Box, Typography, Card, Grid, CardMedia, CardContent, Container } from "@mui/material";
import axios from "axios";
import CatPopup from "../components/CatPopup"; // Importando o popup

function Adoptions() {
  const [cats, setCats] = useState([]);
  const [selectedCat, setSelectedCat] = useState(null);

  // Buscar gatos
  useEffect(() => {
    axios.get("http://localhost:5000/cats").then((res) => {
      setCats(res.data);
    });
  }, []);

  return (
    <Box>
      {/* Módulo Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 220, sm: 320, md: 380 },
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src="/images/banner3.png"
          alt="Adopta"
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>

      {/* Listagem de Gatos */}
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
          sx={{ mt: 3, mb: 3 }}
          justifyContent="center"
        >
          {cats.map((cat) => (
            <Grid item xs={12} sm={6} md={4} key={cat.id}>
              <Card
                sx={{ display: "flex", flexDirection: "column", height: "100%", cursor: "pointer" }}
                onClick={() => setSelectedCat(cat)} // Abrir popup ao clicar
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={`http://localhost:5000/images/cats/${cat.main_photo}`}
                  alt={cat.name}
                />
                <CardContent
                  sx={{
                    flexGrow: 1,
                    paddingBottom: "0 !important",
                    paddingTop: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "16px" }}>
                    {cat.name}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "13px", flexGrow: 1 }}>
                    {cat.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Popup de Detalhes */}
      <CatPopup cat={selectedCat} onClose={() => setSelectedCat(null)} />
    </Box>
  );
}

export default Adoptions;